import React from "react";
import Footer from "../components/footer";
import App from "../containers/App";
import { Card, CardGroup, Container, Row, Col, Table } from "react-bootstrap";
import "./estagios.css";
import tabelaDocumentos from "../components/images/tabelaDocumentos.png";


const setordeestagios = () => (
  <App>
    <Container
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        marginBottom: "50px",
        marginTop: "20px",
      }}
    >
      <p className="setordeestagios-titulo">ESTÁGIOS</p>
    </Container>
    <Container>
      <Card style={{ boxShadow: "0 0 0 0", border: "0 none", outline: "0" }}>
        <Row>
		
        <p id="subtitulo">ORIENTAÇÕES GERAIS
		<br />
		<br />
		</p>
		
		<p id="bold">DOCUMENTAÇÕES PARA FORMALIZAÇÃO DO ESTÁGIO</p>
		
        <p id="espaco">
          Para a formalização do estágio, a empresa concedente ou &nbsp;
			<a
              id="cor"
              target="_blank" rel="noopener noreferrer"
              href="https://agpc.cps.sp.gov.br/agentes-de-integracao/"
            >
               Agente de Integração Credenciado
            </a>
			, poderão usar o(s) modelo(s) próprio(s) de documento(s) para que a celebração seja realizada, desde que esteja(m) de acordo com a &nbsp; 
			<a
              id="cor"
              target="_blank" rel="noopener noreferrer"
              href="https://www.planalto.gov.br/ccivil_03/_ato2007-2010/2008/lei/l11788.htm"
            >
               Lei do Estágio (nº 11.788/08)
            </a>
			&nbsp; e atendendo às diretrizes do Manual de Orientações de Estágio Supervisionado versão 2.0.0, elaborado pela Unidade do Ensino Superior de Graduação – CESU.
        
		<br />
		<br />
		<strong>ABAIXO DISPONIBILIZAMOS MODELOS SUGERIDOS PELA FATEC SJC.</strong>
		<br />
		<br />
		
		<a
		  id="cor"
		  target="_blank" rel="noopener noreferrer"
		  href="https://sjc.fatec.sp.gov.br/downloads/estagio/_MODELO Termo de Compromisso de Estágio.docx"
		>
		   I) TERMO DE COMPROMISSO PARA A REALIZAÇÃO DE ESTÁGIO SUPERVISIONADO
		</a><br />
		<a
		  id="cor"
		  target="_blank" rel="noopener noreferrer"
		  href="https://sjc.fatec.sp.gov.br/downloads/estagio/_MODELO Termo Aditivo.docx"
		>
		   II) TERMO ADITIVO DE PRORROGAÇÃO OU ALTERAÇÃO
		</a><br />
		<a
		  id="cor"
		  target="_blank" rel="noopener noreferrer"
		  href="https://sjc.fatec.sp.gov.br/downloads/estagio/_MODELO CARTA ANUÊNCIA.docx"
		>
		   III) CARTA DE ANUÊNCIA
		</a><br />
		<a
		  id="cor"
		  target="_blank" rel="noopener noreferrer"
		  href="https://sjc.fatec.sp.gov.br/downloads/estagio/_MODELO Termo de Rescisão.docx"
		>
		   IV) TERMO DE RESCISÃO DE ESTÁGIO
		</a><br />
		
		<br />
			Instruções de preenchimento:<br /><br />
			<ol id="lista">
			<li>Colocar o modelo no papel timbrado/logo da empresa concedente.</li>
			<li>Preencher todos os campos.</li>
			<li>Verificar conforme prevê a Lei se:</li>
				<ul id="lista">
					<li>a jornada do estágio não está conflitando com o horário do curso;</li>
					<li>a carga horária diária não excede 06 (seis) horas e 30 (trinta) horas semanais;</li>
					<li>a previsão para término das atividades do estágio não excede a conclusão do curso informada pela a Instituição;</li>
					<li>cumpre o limite de de 02 (dois) anos na mesma empresa concedente/CNPJ.</li>
				</ul>
			<li>Definir o formato de assinatura (de preferência digital ou manual):</li>
				<ul id="lista">
					<li><strong>Digital</strong>: Neste caso todos deverão assinar digitalmente, por meio de plataformas como Autentique, ClickSign, Docusign, entre outras; podendo indicar a Secretaria Acadêmica através do e-mail <font color="blue"><u>f146.secretaria@fatec.sp.gov.br</u></font> (quando não for indicada na plataforma, deverá ser enviado no mesmo e-mail).</li>
					<li><strong>Manual</strong>: imprimir 3 (três) vias, que deverão ser rubricadas em todas as páginas, e assinadas com caneta esferográfica pela concedente, estagiário e instituição, seguidos dos devidos carimbos. A entrega neste caso deverá ser feita presencialmente na Secretaria Acadêmica.</li>
				</ul>
			Lembrando que a Instituição (FATEC) é sempre a última signatária.<br />
				<li>Não serão aceitos termos com a data de início do estágio retroativa. Nestes casos a empresa concedente deverá entregar junto ao Termo uma CARTA DE ANUÊNCIA (modelo nº III), justificando e assumindo total responsabilidade.</li>
				<li>Não assinamos termos com data de emissão futuras.</li>
				<li>Em casos de Rescisão, a Secretaria Acadêmica deverá ser imediatamente informada através de comunicado/termo de rescisão quando por iniciativa da empresa.</li>
			Quando pedido pelo estagiário, o mesmo deverá entregar sua solicitação de rescisão protocolado oficialmente pela empresa concedente.<br />
			</ol>
			
		<br />
		<strong>IMPORTANTE:</strong> O prazo de assinatura por parte da FATEC, é de até 07 (sete) dias úteis durante as primeiras semanas do período letivo, e de até 05 (dias) úteis em períodos de baixa demanda, desde que os documentos apresentados em conformidade com a Lei de Estágios.<br />
		<br />
		Qualquer dúvida, envie uma prévia do documento (sem as assinaturas) no e-mail <font color="blue"><u>f146.secretaria@fatec.sp.gov.br</u></font> para análise.

		</p>
		

		<p id="bold">RELATÓRIO FINAL PARA CONCLUSÃO DA CARGA HORÁRIA DO ESTÁGIO OBRIGATÓRIO</p>
        
		<p id="espaco">
          Após cumprimento das 240 horas de estágio supervisionado previstas no projeto pedagógico do curso, o(a) aluno(a) deverá elaborar o relatório final de estágio supervisionado.<br />
		  Abaixo disponibilizamos modelos sugeridos pela FATEC SJC:
		  <br />
		  <br />
		  <strong>V) MODELOS DE RELATÓRIO FINAL (Versão atual até 1º semestre de 2025):</strong>
			<br />
			<ol id="lista" type="a">
			<a
			  id="cor"
			  target="_blank" rel="noopener noreferrer"
			  href="https://sjc.fatec.sp.gov.br/downloads/estagio/modelo_relatorio_estagio_ads.docx"
			>
			   <li>Análise e Desenvolvimento de Sistemas</li>
			</a>
			<a
			  id="cor"
			  target="_blank" rel="noopener noreferrer"
			  href="https://sjc.fatec.sp.gov.br/downloads/estagio/modelo_relatorio_estagio_bd.docx"
			>
			    <li>Banco de Dados</li>
			</a>
			<a
			  id="cor"
			  target="_blank" rel="noopener noreferrer"
			  href="https://sjc.fatec.sp.gov.br/downloads/estagio/modelo_relatorio_estagio_dsm.pdf"
			>
			    <li>Desenvolvimento de Software Multiplataforma</li>
			</a>
			<a
			  id="cor"
			  target="_blank" rel="noopener noreferrer"
			  href="https://sjc.fatec.sp.gov.br/downloads/estagio/modelo_relatorio_estagio_gpi.docx"
			>
			    <li>Gestão da Produção Industrial</li>
			</a>
			<a
			  id="cor"
			  target="_blank" rel="noopener noreferrer"
			  href="https://sjc.fatec.sp.gov.br/downloads/estagio/modelo_relatorio_estagio_logistica.docx"
			>
			    <li>Logística</li>
			</a>
			<a
			  id="cor"
			  target="_blank" rel="noopener noreferrer"
			  href="https://sjc.fatec.sp.gov.br/downloads/estagio/modelo_relatorio_estagio_mav.docx"
			>
			    <li>Manufatura Avançada</li>
			</a>
			<a
			  id="cor"
			  target="_blank" rel="noopener noreferrer"
			  href="https://sjc.fatec.sp.gov.br/downloads/estagio/modelo_relatorio_estagio_manutencao.docx"
			>
			    <li>Manutenção de Aeronaves</li>
			</a>
			<a
			  id="cor"
			  target="_blank" rel="noopener noreferrer"
			  href="https://sjc.fatec.sp.gov.br/downloads/estagio/modelo_relatorio_estagio_pea.docx"
			>
			    <li>Projetos de Estruturas Aeronáuticas</li>
			</a>
			<a
			  id="cor"
			  target="_blank" rel="noopener noreferrer"
			  href="https://sjc.fatec.sp.gov.br/downloads/estagio/modelo_relatorio_trabalho_equivalente_estagio.docx"
			>
			    <li>Modelo de Relatório de Trabalho Equivalente ao Estágio</li>
			</a>
			</ol>
		
		
			<strong>VI) MODELOS DE RELATÓRIO FINAL (Próxima Versão em 2º semestre de 2025):</strong>
			<br />
			
			<ol id="lista" type="a">
			<a
			  id="cor"
			  target="_blank" rel="noopener noreferrer"
			  href="https://sjc.fatec.sp.gov.br/downloads/estagio/_MODELO Relatório Final - FATEC.docx"
			>
			   <li>Relatório de Estágio (todos os cursos)</li>
			</a>
			<a
			  id="cor"
			  target="_blank" rel="noopener noreferrer"
			  href="https://sjc.fatec.sp.gov.br/downloads/estagio/_MODELO Relatório Final com equivalência- FATEC.docx"
			>
			   <li>Relatório de Atividades Profissionais Equivalentes ao Estágio</li>
			</a>
			</ol>
			
			Instruções de preenchimento <strong>(modelos 2º semestre de 2025)</strong>:<br /><br />
			<ol id="lista">
			<li>Preencher todos os campos e elaborar os textos dos capítulos dos modelos, com as informações solicitadas, baseando-se nas atividades desenvolvidas no estágio.</li>
			<li>A declaração e a avaliação constantes no modelo em papel timbrado/logo da empresa concedente.</li>
			<li>Definir o formato de assinatura (<strong><u>de preferência digital</u></strong> ou manual):</li>
				<ul id="lista">
					<li><strong>Digital</strong>: Neste caso todos deverão assinar digitalmente, por meio de plataformas como Autentique, ClickSign, Docusign, entre outras.</li>
					<li><strong>Manual</strong>: imprimir 1 (uma) via, que deverá ser rubricada em todas as páginas, e assinada com caneta esferográfica pela concedente e estagiário, seguidos dos devidos carimbos. A entrega neste caso deverá ser feita presencialmente na Secretaria Acadêmica.</li>
				</ul>
			<li>Lembrando que a Instituição (FATEC) receberá somente relatórios preenchidos e assinados corretamente, seguindo as instruções.</li>
			<li>Em casos de equivalência de Estágio, deverá preencher o “Relatório de Atividades Profissionais Equivalentes Ao Estágio” seguindo as instruções acima. Neste caso o “ANEXO - Pedido De Equivalência De Atividades Profissionais Com Estágio Obrigatório” deverá ser preenchido e os seguintes documentos comprobatórios deverão ser anexados:</li>
				<ul id="lista">
					<li>Registro na Carteira de Trabalho (acompanhada de cópia das páginas de identificação da carteira);</li>
					<li>Contrato de trabalho com o nome do aluno.</li>
					<li>Documento em papel timbrado da empresa com a descrição técnica detalhada das atividades exercidas pelo aluno e o tempo em que as exerce, com firma reconhecida.</li>
				</ul>
			<br />
			Quando o aluno atua como autônomo/CNPJ/MEI na área de formação é necessário apresentar:<br />
				<ul id="lista">
					<li>Contrato social;</li>
					<li>Registro como autônomo;</li>
					<li>Recibos RPA;</li>
					<li>Contratos de prestação de serviços, comprovando a carga horária mínima de atividades ou declaração do tomador de serviço com a devida comprovação, ambos em papel timbrado com firma reconhecida.</li>
				</ul>
			<br />
			Tais comprovações deverão ser analisadas pelo coordenador do curso e pela equipe de apoio técnico administrativo responsável pelas ações relacionadas ao processo de estágio na unidade.<br />
			</ol>

		</p>
			
        </Row>
      </Card>
    </Container>
    <Footer />
  </App>
);

export default setordeestagios;
